const RemoveLoginStatusInSession = () => {
  if (sessionStorage.getItem("login_user")?.length !== 0) {
    sessionStorage.clear();
    return true;
  }
};

export default RemoveLoginStatusInSession;
